export default "__VITE_ASSET__BA6Nd1X2__"